

module.exports = __webpack_require__.stylable.create(
    "Collapse1396062670",
    {"classes":{"root":"Collapse1396062670__root","collapse":"Collapse1396062670__collapse"},"vars":{},"stVars":{},"keyframes":{}},
    ".Collapse1396062670__collapse{transition:height 500ms}",
    1,
    "Collapse1396062670",
    __webpack_require__.stylable.$
);
